import React from "react";
import RoleListItem from "../../components/role/RoleList/RoleListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const RoleListPage = ()  => {

    useTitle(t`List Role`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <RoleListItem showAdd={true} {...query} />
        </Box>
    )
}

export default RoleListPage;
